export default __webpack_public_path__ + "static/GT-America-Standard-Medium-6d55b79007ae583c0f7f0b33b8c49b40.woff2";